import gql from "graphql-tag";

export const MY_TAX_GET_FIRST_MERRIED_PERSON_DECLARATION = gql`
  query taxDeclarationFirstMarriedPerson($_id: Int!) {
    taxDeclarationFirstMarriedPerson(_id: $_id) {
      dateOfDeclaration
      isModifiedDeclaration
      state
      spouseName
      spouseTaxNumber
      spouseEmployerName
      spouseEmployerTaxNumber
      marriageDate
      applyFromMonth
      requestAmount
      noApply
      applyInTaxYear
      applyToWithdrawal
    }
  }
`;
